import {DG_axios} from "../../../custom/axios";

const url = `/dogoo/resource-action-rest/v2.0/resource/action`

const urlWorkspace = `/dogoo/resource-action-rest/v2.0/resource/workspaces`

export async function getActionAccount(accountId, key) {
    const response = await DG_axios.get(url + `/account/${accountId}?moduleKeys=${key}`)
    return response?.data || []

}

export async function getWorkspaceKeys(accountId, workspaceKey) {

    const response = await DG_axios.get(urlWorkspace + `/${workspaceKey}/accounts/${accountId}`)

    return response?.data || []
}
